import * as yup from 'yup'
import { createDataRef, createDataSchema, createPropertiesSchema } from '../schemaUtils'
import { videoBackgroundProperties } from '../media/Video.schema'

export type A11yRole = 'heading' | 'status' | 'alert'
export type AriaLive = 'polite' | 'assertive'
export type AriaCurrent = 'step' | 'page' | 'true' | 'false'

export const stripColumnsContainerA11y = createDataSchema(
	'StripColumnsContainerA11y',
	yup.object({
		label: yup.string().max(1000),
		tabindex: yup.number().min(-1).max(0),
		live: yup.mixed<AriaLive>().oneOf(['polite', 'assertive']),
		role: yup.mixed<A11yRole>().oneOf(['heading', 'status', 'alert']),
		atomic: yup.boolean(),
		hidden: yup.boolean(),
		current: yup.mixed<AriaCurrent>().oneOf(['step', 'page', 'true', 'false']),
		level: yup.number(),
	})
)

export type StripColumnsContainerA11y = yup.InferType<typeof stripColumnsContainerA11y>

export const dataSchema = createDataSchema(
	'StripColumnsContainer',
	yup.object({
		a11y: createDataRef({ StripColumnsContainerA11y: stripColumnsContainerA11y }).nullable(),
	})
)

export const propertiesSchema = createPropertiesSchema(
	'StripColumnsContainerProperties',
	yup
		.object({
			columnsMargin: yup.number().default(15),
			rowMargin: yup.number().default(15),
			siteMargin: yup.number().default(15),
			fullWidth: yup.boolean().default(true),
		})
		.concat(videoBackgroundProperties)
)
